import { type ProjectCode, projectNameMap } from '@constants'
import { type BrandInfo } from '../../../constants'
// 不走 constants barrel：barrel 會連帶載入 stylex themes，測試環境沒有 babel plugin 會直接炸
import { brandImageMap } from '../../../constants/brand-image-map'
import { DEFAULT_QUICK_ORDER_PROJECT_CODE } from '../../../hooks/use-stm-quick-order-store'
import { type FastOrderBrandDto } from '../../dtos/fast-order-brand-dto'

export interface BrandSelectOption {
  projectCode: ProjectCode
  label: string
  isDefault: boolean
  iconSrc?: string
}

export const buildBrandSelectOptions = (fastOrderBrands: FastOrderBrandDto[], activeBrands: BrandInfo[]): BrandSelectOption[] => {
  const activeProjectCodes = new Set(activeBrands.map(brand => brand.projectCode))
  const fromApi = fastOrderBrands
    .filter(brand => activeProjectCodes.has(brand.projectCode))
    .map(brand => ({ projectCode: brand.projectCode, label: brand.brandName, isDefault: brand.isDefault }))
  const fromActive = [...activeProjectCodes]
    .map(projectCode => ({ projectCode, label: projectNameMap[projectCode] ?? projectCode, isDefault: projectCode === DEFAULT_QUICK_ORDER_PROJECT_CODE }))

  return (fromApi.length ? fromApi : fromActive).map(option => ({ ...option, iconSrc: brandImageMap[option.projectCode]?.icon }))
}

/** 目前選的品牌不在選項裡（例如店家沒註冊該品牌）時，改選預設品牌，沒有預設就選第一個 */
export const resolveSelectedProjectCode = (options: BrandSelectOption[], selectedProjectCode: ProjectCode): ProjectCode | null => {
  const [firstOption] = options
  if (!firstOption || options.some(option => option.projectCode === selectedProjectCode)) return null
  return (options.find(option => option.isDefault) ?? firstOption).projectCode
}
